import PropTypes from 'prop-types';

export const actionsType = PropTypes.arrayOf(
  PropTypes.shape({
    key: PropTypes.string.isRequired,
    color: PropTypes.string,
    variant: PropTypes.string,
    label: PropTypes.string,
    icon: PropTypes.element,
    onClick: PropTypes.func.isRequired,
  }),
);

export const orderType = PropTypes.arrayOf(
  PropTypes.shape({
    key: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
    ]),
    label: PropTypes.string,
    renderFunc: PropTypes.func,
  }),
);

export const extrasDefinitionType = PropTypes.shape({
  title: PropTypes.string,
  lineItems: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.node,
      renderFunc: PropTypes.func,
    }),
  ),
});

export const formDefinitionType = PropTypes.arrayOf(
  PropTypes.shape({
    autoFocus: PropTypes.bool,
    type: PropTypes.oneOf([
      'text',
      'number',
      'combobox',
      'select',
      'checkbox',
      'datetime-local',
      'mcc-mnc-typeahead',
      'tags-select',
    ]),
    label: PropTypes.string.isRequired,
    valueKey: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
          value: PropTypes.any,
          label: PropTypes.string,
        }),
      ]),
    ),
    maximum: PropTypes.number,
    minimum: PropTypes.number,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
  }),
);
